// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"166d4886","513":"3bd67912","703":"49632b34","787":"93fbefaa"}[chunkId] + ".chunk.js";
};